import React from 'react'
import styles from './InputVariant2.module.css';
import { FiSearch } from "react-icons/fi";
import Spinner from 'Common/Spinner';
const InputVariant2 = (props) => {
    return (
        <div className={styles.varriant2}>
            <div className='absolute transform -translate-y-1/2 left-2 top-1/2'> <FiSearch size={16} className='text-[#8D8D8D]' /></div>
            <input
                onKeyDown={props.handleOnKeyDown}
                disabled={props.variantDisabled}
                onChange={props.handleChange}
                value={props.searchValue}
                id={`superSearchInputField_${props.variantID}`}
                type="text"
                autoComplete="off"
                className={styles.varriant1_input2}
                placeholder={props.variantPlaceholder}
            />
            {
                props.searchValue ? (

                    <button type="button" className='absolute transform -translate-y-1/2 right-2 top-1/2' onClick={props.resetComponent}   >
                        {props.loading ? <Spinner /> : props.variantCrossIcon}
                    </button>
                ) : null
            }


        </div>
    )
}

export default InputVariant2